<template>
  <div id="productandservice"><router-view></router-view></div>
</template>

<script>
export default {
  mounted() {
    this.changStyle();
  },
  methods: {
    changStyle() {
      var serviceA=document.getElementById('serviceA');
      serviceA.style.color='#74B6EC';
      serviceA.style['font-weight'] = 'bold';
      serviceA.onmouseover=function(){
        serviceA.style.color="#74B6EC";
      }
      serviceA.onmouseout=function(){
        serviceA.style.color='#74B6EC';
      }
      var solutionA=document.getElementById('solutionA');
      solutionA.style.color='#000';
      solutionA.style['font-weight'] = 'normal';
      solutionA.onmouseover=function(){
        solutionA.style.color="#74B6EC";
      }
      solutionA.onmouseout=function(){
        solutionA.style.color='#000';
      }
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/ProductAndService.vue